import CrmInvoiceStore from './CrmInvoiceStore/CrmInvoiceStore'
import CrmUsageStore from '../CrmUsageStore/CrmUsageStore'
import { $RootStore } from '../../../src/stores/RootStore'
import { computed, observable } from 'mobx'
import CrmUsageModel from '../CrmUsageStore/CrmUsageModel'
import CrmInvoiceModel from './CrmInvoiceStore/CrmInvoiceModel'

export default class CrmStore {
  rootStore: $RootStore
  crmUsageStore: CrmUsageStore
  crmInvoiceStore: CrmInvoiceStore
  @observable accessor crmErrors: CrmUsageError[] = []
  @observable accessor _loading = false

  constructor(rootStore: $RootStore) {
    this.rootStore = rootStore
    this.crmUsageStore = new CrmUsageStore(rootStore, CrmUsageModel)
    this.crmInvoiceStore = new CrmInvoiceStore(rootStore, CrmInvoiceModel)
  }

  @computed get loading() {
    return this.crmUsageStore.loading || this.crmInvoiceStore.loading || this._loading
  }

  fetchCrmErrors_api = async () => {
    const { communication: { requester } } = this.rootStore

    this._loading = true

    try {
      const response = await requester.crmUsageErrors()
      this.crmErrors = response.crmUsageErrors || []
      this._loading = false
    } catch (e) {
      this._loading = false
    }
  }

  deleteAllErrors_api = async () => {
    const { communication: { requester } } = this.rootStore

    this._loading = true

    try {
      await requester.deleteCrmUsageErrors()
      this.crmErrors = []
      this._loading = false
    } catch (e) {
      this._loading = false
    }
  }

  clearData = () => {
    this.crmUsageStore.clearData()
    this.crmInvoiceStore.clearData()
    this.crmErrors = []
  }
}